//Mega Menu//
document.querySelectorAll('.button-menu').forEach(menu => {
  menu.addEventListener('click', function (e) {
    // Check if a button was clicked
    const button = e.target.closest('.custom-button');
    if (!button) return;

    // Get the menu type (e.g., filament or printer)
    const menuType = this.getAttribute('data-menu');

    // Remove 'active' from all buttons in this menu
    this.querySelectorAll('.custom-button').forEach(btn => btn.classList.remove('active'));

    // Add 'active' class to the clicked button
    button.classList.add('active');

    // Get the label of the clicked button
    const label = button.getAttribute('data-label');

    // Find the corresponding content group
    const contentGroup = document.querySelector(`.content-group[data-group="${menuType}"]`);

    if (contentGroup) {
      // Show the matching content and hide others in this group
      contentGroup.querySelectorAll('.button-content').forEach(content => {
        if (content.id === label) {
          content.style.display = 'flex';
        } else {
          content.style.display = 'none';
        }
      });
    } else {
      console.error(`Content group for menu type "${menuType}" not found.`);
    }
  });
});

// Mobile Menu //
// Hamburger Menu //
const hamburger = document.getElementById('hamburger-button');
const menu = document.getElementById('menu');
const mobileSubnav = document.getElementById('mobile-subnav'); // Select the mobile subnav

hamburger.addEventListener('click', () => {
  const img = hamburger.querySelector('img');
  const isMenuOpen = menu.style.display === 'block';

  // Toggle menu display
  menu.style.display = isMenuOpen ? 'none' : 'block';

  // Toggle mobile subnav display
  mobileSubnav.style.display = isMenuOpen ? 'none' : 'block';

  // Switch hamburger icon
  img.src = isMenuOpen 
    ? 'https://cdn.shopify.com/s/files/1/2104/4351/files/Icon-hamburger.svg?v=1732656615' 
    : 'https://cdn.shopify.com/s/files/1/2104/4351/files/Icon-close.svg?v=1732659101';
});

// Screen Resize Listener //
window.addEventListener('resize', () => {
  if (window.innerWidth > 948) {
    // Hide the mobile subnav and menu if the screen width is greater than 958px
    mobileSubnav.style.display = 'none';
    menu.style.display = 'flex';

    // Reset the hamburger icon
    const img = hamburger.querySelector('img');
    img.src = 'https://cdn.shopify.com/s/files/1/2104/4351/files/Icon-hamburger.svg?v=1732656615';
  }
});

// Mobile Menu Dropdown Click Handling
document.querySelectorAll('#mobile-menu .dropdown > a').forEach((dropdownLink) => {
  dropdownLink.addEventListener('click', (event) => {
    event.preventDefault(); // Prevent the default link behavior
    const parentDropdown = dropdownLink.parentElement;

    // Toggle the visibility of the subnav
    const subnav = parentDropdown.querySelector('.subnav');
    if (subnav) {
      subnav.style.display = subnav.style.display === 'block' ? 'none' : 'block';
    }
  });
});

// Mega Menu Hover Handling
const megaMenuContainer = document.querySelector('#mega-menu-container');
const menuItems = document.querySelectorAll('.menu-item.dropdown a');

let hideTimeout;

menuItems.forEach((item) => {
  item.addEventListener('mouseenter', function () {
    clearTimeout(hideTimeout);

    const targetId = item.dataset.item;
    const target = document.querySelector(`#${CSS.escape(targetId)}`);

    // Clear other active states
    menuItems.forEach(link => link.classList.remove('se'));

    // Add active state to current item
    item.classList.add('se');

    // Update mega menu content
    document.querySelectorAll('.mega-menu-content').forEach(div => {
      div.classList.remove('active');
    });

    if (target) {
      target.classList.add('active');
    }

    megaMenuContainer.style.display = 'block';
  });

  item.addEventListener('mouseleave', function () {
    startHideTimer();
  });
});

megaMenuContainer.addEventListener('mouseenter', function () {
  clearTimeout(hideTimeout);
});

megaMenuContainer.addEventListener('mouseleave', function () {
  startHideTimer();
});

function startHideTimer() {
  hideTimeout = setTimeout(() => {
    // Only hide if mouse is not over menu triggers or mega menu
    if (
      !megaMenuContainer.matches(':hover') &&
      !document.querySelector('.menu-item.dropdown a:hover')
    ) {
      megaMenuContainer.style.display = 'none';

      // Remove all active states
      menuItems.forEach(link => link.classList.remove('se'));

      document.querySelectorAll('.mega-menu-content').forEach(div => {
        div.classList.remove('active');
      });
    }
  }, 150);
}

// Additional event listener for the mega menu container to handle mouse leave
document.querySelector('#mega-menu-container').addEventListener('mouseleave', function () {
  checkIfShouldHideMegaMenu();
});

// Function to check if both the item and container should hide the mega menu
function checkIfShouldHideMegaMenu() {
  const megaMenuContainer = document.querySelector('#mega-menu-container');
  if (!megaMenuContainer.matches(':hover') && !document.querySelector('.menu-item.dropdown:hover')) {
    // Only hide if the mouse has left both the item and the container
    megaMenuContainer.style.display = 'none';
    document.querySelectorAll('.menu-item.dropdown a').forEach(item => item.classList.remove('active'));
  }
}

// Reset the active state when the menu closes or changes
hamburger.addEventListener('click', () => {
  const isMenuOpen = menu.style.display === 'block';

  if (!isMenuOpen) {
    // Remove active class from all menu items when the menu is closed
    document.querySelectorAll('.menu-item.dropdown a').forEach(item => item.classList.remove('active'));
  }
});

// Manages the images  
document.querySelectorAll('.linked-navbar-image').forEach(function (element) {
  const bgImage = element.getAttribute('data-bg-image');
  element.style.backgroundImage = bgImage;
});
